import axios from 'utils/axios';
import type { EmailEntryType, EmailEntryWriteType } from '@econtractor/types';

export const getList = async (): Promise<EmailEntryType[] | null> => {
    try {
        const res = await axios('/emails-dir');
        return res.data;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const save = async (id: number | null, values: EmailEntryWriteType): Promise<string | null> => {
    try {
        await axios.post(id === null ? '/emails-dir' : `/emails-dir/${id}`, values);
        return null;
    } catch (error) {
        return (error as { errCode?: string })?.errCode || 'UNKNOWN';
    }
};

export const remove = async (id: number): Promise<boolean> => {
    try {
        await axios.delete(`/emails-dir/${id}`);
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};
